import SEO from "@/components/SEO";

const sections = [
  [
    "1. Scope",
    <p>
      These terms govern your use of the LightningFlow website, public
      information, enquiry forms and general online services. Halo SuperVPN
      subscriptions, Halo Traveller reservations and other specific offers may
      have additional terms presented before you subscribe, reserve or buy. SecureShield Pro direct purchases are also governed by the <a className="underline" href="/secureshield/pro-terms">SecureShield Pro terms</a> and <a className="underline" href="/secureshield/refunds">refund policy</a>.
    </p>,
  ],
  [
    "2. Using LightningFlow",
    <p>
      Use the website lawfully and respectfully. Do not attempt to interfere
      with the website, bypass security, introduce malicious code, misuse forms
      or access information that is not intended for you.
    </p>,
  ],
  [
    "3. Product information",
    <p>
      Product availability, pricing, supported platforms and service details
      are shown on the relevant LightningFlow product page or purchasing
      provider. Information supplied through an enquiry should be accurate so
      we can respond to you effectively.
    </p>,
  ],
  [
    "4. Accounts and access",
    <p>
      You are responsible for keeping account access secure and for activity
      completed through your account. Contact LightningFlow Support promptly if
      you believe an account or connection has been used without permission.
    </p>,
  ],
  [
    "5. Intellectual property",
    <p>
      LightningFlow, Halo SuperVPN, QuantumCloak, QuantumCubeDB, Sheila AI and
      associated software, designs, text, graphics and branding are protected
      by intellectual-property laws. Website access does not transfer ownership
      or grant permission to copy, modify or commercialise that material.
    </p>,
  ],
  [
    "6. Third-party services",
    <p>
      Links to Microsoft, Apple, Google, Stripe and other providers take you to
      services governed by their own terms and privacy practices. The provider
      that processes a purchase also manages its payment method, receipt and
      billing controls.
    </p>,
  ],
  [
    "7. Australian Consumer Law",
    <p>
      Nothing in these terms excludes, restricts or modifies a right, remedy,
      guarantee or other protection that cannot lawfully be excluded under the
      Australian Consumer Law. Any limitation in these terms applies only to
      the extent permitted by law.
    </p>,
  ],
  [
    "8. Governing law and contact",
    <p>
      These terms are governed by the laws of South Australia, Australia.
      Questions can be sent to{" "}
      <a
        className="underline"
        href="mailto:contact@lightningflow.ai?subject=LightningFlow%20terms"
      >
        contact@lightningflow.ai
      </a>
      .
    </p>,
  ],
];

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Use — LightningFlow"
        description="Terms governing the LightningFlow website and general online services."
        canonicalPath="/terms"
      />
      <section className="border-b border-ink-100 bg-ink-50/50">
        <div className="lf-container py-16 md:py-20">
          <div className="lf-eyebrow">LightningFlow terms</div>
          <h1 className="mt-5 max-w-4xl font-display text-5xl font-black leading-tight md:text-6xl">
            Clear terms for using LightningFlow.
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-relaxed text-ink-600">
            These terms cover the LightningFlow website and general online
            services, with product-specific terms available where they apply.
          </p>
          <p className="mt-3 text-sm text-ink-500">
            Effective 31 July 2026
          </p>
        </div>
      </section>
      <section className="lf-section">
        <div className="lf-container max-w-4xl space-y-5">
          {sections.map(([title, content]) => (
            <article key={title} className="border border-ink-100 bg-white p-6 md:p-8">
              <h2 className="font-display text-2xl font-bold">{title}</h2>
              <div className="mt-4 space-y-4 text-sm leading-relaxed text-ink-600 md:text-base">
                {content}
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
